export default __webpack_public_path__ + "static/media/PersonswithDisabilities_fr.5dd98512.svg";